import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./Components/Navbar";
import ScrollToTop from "./Components/ScrollToTop";
import AppRoutes from "./routes/Routes";
import Footer from "./Components/Footer";
import { FaChevronUp } from 'react-icons/fa';

import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop/>
      <AppRoutes />
      <Footer/>
      {/* Back to Top */}
            <a href="#" className="fixed bottom-10 right-10 bg-gradient-to-b from-[#1BB095] to-teal-900 p-4 rounded-full text-white text-xl z-10">
            <FaChevronUp size={20} className="text-white hover:text-blue-800 transition duration-300" />
            </a>
    </Router>
  );
}

export default App;
